import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReturnLogModel } from '../Models/return-log.model';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ElementReturnService {
  private apiUrl = environment.apiBaseUrl + "/ElementReturn"; // API-Pfad anpassen

  constructor(private http: HttpClient) { }

  recordReturn(returnData: {
    elementId: number;
    quantity: number;
    reason: string;
    comments?: string;
    relatedWithdrawalId?: number;
  }): Observable<any> {
    return this.http.post(this.apiUrl, returnData);
  }

  getReturnHistoryByElement(elementId: number): Observable<ReturnLogModel[]> {
    return this.http.get<ReturnLogModel[]>(`${this.apiUrl}/element/${elementId}`);
  }

  getRecentReturns(count: number = 100): Observable<ReturnLogModel[]> {
    return this.http.get<ReturnLogModel[]>(`${this.apiUrl}/recent?count=${count}`);
  }

  getMyReturns(): Observable<ReturnLogModel[]> {
    return this.http.get<ReturnLogModel[]>(`${this.apiUrl}/user`);
  }
}
